import { render } from "./TheDropshipping.vue?vue&type=template&id=3e6edcee&scoped=true"
import script from "./TheDropshipping.vue?vue&type=script&lang=js"
export * from "./TheDropshipping.vue?vue&type=script&lang=js"

import "./TheDropshipping.vue?vue&type=style&index=0&id=3e6edcee&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6edcee"]])

export default __exports__